import { getDomainList } from './CorrelatorService';

export default class DomainListService  {

    LIST_TYPE = {
        TECHNICIANS: "technicians", SURVEY_TYPES: "surveytypes", CUSTOMERS: "customers", DATA_TYPES: "datatypes",
        SURVEY_STATES: "surveystates", AREAS: "areas"
    };

    getDomainList = (listType, callback, errorCallback) => {
            var list = [];
            getDomainList(listType).then(res => res)
                .then((data) => {
                    data.forEach(function (item, i) {
                        list.push({ text: item.value, key: item.value });
                    });
                   console.log(list);
                    callback(list)
                })
                .catch(console.log)   
    };

}